const STORAGE_KEY = "bjr_session";

export function getSessionCookie(): string | null {
  if (typeof window === "undefined" || !window.localStorage) return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // localStorage peut être bloqué (mode privé, iframe sandbox, etc.)
    return null;
  }
}

export function setSessionCookie(token: string | null): void {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    if (token) {
      localStorage.setItem(STORAGE_KEY, token);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Silently fail if localStorage is blocked
  }
}
